/* eslint-disable no-template-curly-in-string */

export const messages = {
  emailError: "Invalid Email ID",
  passwordError: "Invalid Password",
  accBlockError:
    "Your application has been blocked due to 3 failed password attempts. Please contact your admin",
  passwordToExpire: "Your password will expires in 2 days!",
  passwordExpiredTitle: "Your password has expired!",
  passwordExpiredDec:
    "You have reached the maximum age of 90 days for your previous password.",
  newPassConfirmPassMatch: "Password did not match.",
  lastFivePassword: "Last 5 passwords cannot be reused.",
  createNewPassword: "Create a new password for security reasons.",
};

export const VALIDATION = {
  required: "${label} is required",
  email: "Invalid ${label}.",
  match: "The two passwords that you entered do not match !"
};

export const ACCOUNT_BLOCKED =
  "You account has been blocked due to 3 failed password attempts. Please contact your Admin.";
export const PASSWORD_EXPIRED_TITLE = "Your password has expired!";
export const PASSWORD_EXPIRED_DESCRIPTION =
  "You have reached the maximum age of 90 days for your previous password.";
export const PASSWORD_EXPIRY = "Your password will expires in 2 days!";

